import styled from '@emotion/styled';

const Hr = styled.hr`
  border-color: rgba(0, 0, 0, 0.12);
  border-width: 0px 0px thin;
  margin: 0;
`;

export default Hr;
